export const CabinIcon = () => {
	return (
		<svg width="14" height="14" viewBox="0 0 14 14" fill="none" xmlns="http://www.w3.org/2000/svg">
			<path d="M5.5 7.75H4V6.25H5.5V7.75ZM10 6.25H8.5V7.75H10V6.25ZM13.75 12.25V13.75H0.25V12.25H1V1.75C1 0.925 1.675 0.25 2.5 0.25H11.5C12.325 0.25 13 0.925 13 1.75V12.25H13.75ZM6.25 1.75H2.5V12.25H6.25V1.75ZM11.5 1.75H7.75V12.25H11.5V1.75Z" fill="currentColor" />
		</svg>
	)
}
